import React from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { Order as OrderModel, ORDER_STATUS } from 'msp-integrations'

const translations = defineMessages({
  PROCESSING: {
    defaultMessage: 'The order is being processed',
    id: 'msp.account.order_history.order_status.processing'
  },
  READY_FOR_SHIPPING: {
    defaultMessage: 'The order is being prepared for shipping',
    id: 'msp.account.order_history.order_status.preparing'
  },
  SHIPPED: {
    defaultMessage: 'The order is on its way to you',
    id: 'msp.account.order_history.order_status.shipped'
  },
  DELIVERED: {
    defaultMessage: 'The order has been delivered',
    id: 'msp.account.order_history.order_status.delivered'
  },
  RETURNED: {
    defaultMessage: 'The order has been returned',
    id: 'msp.account.order_history.order_status.returned'
  },
  PARTIALLY_RETURNED: {
    defaultMessage: 'The order has been partially returned',
    id: 'msp.account.order_history.order_status.partially_returned'
  },
  CANCELLED: {
    defaultMessage: 'The order was cancelled',
    id: 'msp.account.order_history.order_status.cancelled'
  }
})

type OrderStatusProps = {
  order: OrderModel
  className?: string
}

const OrderStatus = ({ order, className = '' }: OrderStatusProps) => {
  const { formatMessage } = useIntl()

  if (!order.c_overallStatus && order.status === 'cancelled') {
    order.c_overallStatus = 'CANCELLED'
  }

  const orderStatus = order.c_overallStatus || ORDER_STATUS.PROCESSING

  return (
    <div
      className={`font-Roboto tracking-0 leading-18 text-16 max-h-[36px] overflow-hidden text-ellipsis text-black ${className}`}
    >
      {formatMessage(translations[orderStatus])}
    </div>
  )
}

export default OrderStatus
